import React from "react";
import { InputGroup } from "react-bootstrap";

const INR = <i className="fa fa-inr" aria-hidden="true"></i>;

export const EditTaxInputBox = (props) => {
  return (
    <div className="pb-3 row">
      <div className="col-6">
        <div className="f14-500">{props.taxName}</div>
      </div>
      <div className="col-6">
        <InputGroup className="enInputwithText border-0 rounded-0">
          <input type="number" value={props.taxNameValue} disabled />
          <InputGroup.Prepend>
            <InputGroup.Text className="border-0 rounded-0">
              {props.tax_Value === "PERCENTAGE"
                ? "%"
                : props.tax_Value === "VALUE"
                ? INR
                : null}
            </InputGroup.Text>
          </InputGroup.Prepend>
        </InputGroup>
      </div>
    </div>
  );
};
